<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="firstName"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="clientName"
				[defaultFilterLabel]="filterLabels.clientName"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.clientName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('clientName')"
								data-automation-id="client-name-input"
								(ngModelChange)="dataSet.filter('clientName', filterLabels.clientName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.idn }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('idn')"
								data-automation-id="idn-input"
								(ngModelChange)="dataSet.filter('idn', filterLabels.idn, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.propertyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('propertyName')"
								data-automation-id="property-name-input"
								(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.address }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('address')"
								data-automation-id="address-input"
								(ngModelChange)="dataSet.filter('address', filterLabels.address, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.serialNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('serialNumber')"
								data-automation-id="serial-number-input"
								(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (canAddClients) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@clientList-Add"
					(click)="onAddButtonClick()"
					data-automation-id="client-add-button"
				></app-data-set-action-button>
			</div>
		}

		<div class="client-toggle">
			<mat-slide-toggle
				labelPosition="before"
				[checked]="showInactive"
				(change)="onToggleInactive($event)"
				i18n="@@clientList-showInactiveClients"
				data-automation-id="show-inactive-toggle"
				>Show Inactive Clients &nbsp;
			</mat-slide-toggle>
		</div>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getClientsLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getClientsLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-Name">Name</th>
					<td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
				</ng-container>

				<ng-container matColumnDef="idn">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-IDN">Client IDN</th>
					<td mat-cell *matCellDef="let row">{{ row.idn }}</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-Property">Property</th>
					<td mat-cell *matCellDef="let row">{{ row.property?.name || '- - -' }}</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-Address">Address</th>
					<td mat-cell *matCellDef="let row">
						@if (row.address) {
							<div [innerHtml]="row.address | address"></div>
						}
						@if (!row.address) {
							<div>- - -</div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-Status">Status</th>
					<td mat-cell *matCellDef="let row">
						<mat-chip-set>
							<mat-chip class="status-chip" [ngClass]="row.active ? 'status-chip-active' : 'status-chip-inactive'">
								&bull;&NonBreakingSpace;
								@if (row.active) {
									<span i18n="@@clientList-Active">Active</span>
								}
								@if (!row.active) {
									<span i18n="@@clientList-Inactive">Inactive</span>
								}
							</mat-chip>
						</mat-chip-set>
					</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-SerialNumber">Serial Number</th>
					<td mat-cell *matCellDef="let row">{{ row.serialNumber || '- - -' }}</td>
				</ng-container>

				<ng-container matColumnDef="numberOfCompanies">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-NumberOfCompanies">
						# of Companies
					</th>
					<td mat-cell *matCellDef="let row">
						{{
							row.numberOfCompanies !== null && row.numberOfCompanies !== undefined ? row.numberOfCompanies : '- - -'
						}}
					</td>
				</ng-container>

				<ng-container matColumnDef="numberOfContacts">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-NumberOfContacts"># of Contacts</th>
					<td mat-cell *matCellDef="let row">
						{{ row.numberOfContacts !== null && row.numberOfContacts !== undefined ? row.numberOfContacts : '- - -' }}
					</td>
				</ng-container>

				<ng-container matColumnDef="deviceSource">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@clientList-Source">Source</th>
					<td mat-cell *matCellDef="let row">
						@if (row.deviceSource) {
							<div class="source-container row-left spacing-8">
								@if (isOwnedDevice(row)) {
									<mat-icon class="icon-device-group-owned" svgIcon="sl-device-group-owned"></mat-icon>
								} @else {
									<mat-icon class="icon-device-group-inherited" svgIcon="sl-device-group-inherited"></mat-icon>
								}
								{{ row.deviceSource }}
							</div>
						}
						@if (!row.deviceSource) {
							<span>- - -</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
					<td mat-cell *matCellDef="let row"></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'client-' + row.id + '-row'"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
